// All *_mxn values from the API are INTEGER CENTAVOS.
// Display = centavos / 100. Inputs from the user → multiply by 100 + round.
// Never use float math for money in this codebase.
export const fmtPesos = (cents) => {
    const c = Number(cents ?? 0);
    return `$${(c / 100).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
export const fmtPesosShort = (cents) => {
    const c = Number(cents ?? 0);
    return `$${(c / 100).toLocaleString("es-MX", { maximumFractionDigits: 0 })}`;
};
// User typed "145.50" → 14550 centavos. Empty / NaN → 0.
export const parsePesosInput = (raw) => {
    const n = typeof raw === "number" ? raw : parseFloat(String(raw).replace(/[^\d.-]/g, ""));
    if (!isFinite(n))
        return 0;
    return Math.round(n * 100);
};
// Centavos → editable string ("145.50") for inputs
export const pesosForInput = (cents) => {
    const c = Number(cents ?? 0);
    return (c / 100).toFixed(2);
};
